// DS2.5.1
import React from 'react';
import c from 'classnames';
import NotificationCounter, {
  Props as NotificationCounterProps,
} from '../../Indicators/NotificationCounter';
import IconButton, { Props as IconButtonProps } from '../IconButton';
import shortenNumber from '../../../utils/shortenNumber';
import s from './IconButtonWithNotification.scss';

export type Props = IconButtonProps & {
  className?: string;
  iconButtonClassName?: string;
  numberClassName?: string /* pass border-color matching the background - to create an effect of emptiness between icon and number */;
  count?: number;
  notificationColor?: NotificationCounterProps['color'];
};

export function limitNumber(number: number) {
  return number > 999 ? shortenNumber(number, 0, Math.floor) : `${number}`;
}

const IconButtonWithNotification: React.FC<Props> = ({
  className,
  iconButtonClassName,
  numberClassName,
  count,
  notificationColor,
  ...iconButtonProps
}) => {
  return (
    <div className={c(s['icon-button-wrapper'], className)}>
      <IconButton
        {...iconButtonProps}
        className={c(s['root'], iconButtonClassName)}
      />
      {!!count && (
        <NotificationCounter
          className={c(s['number'], numberClassName)}
          color={notificationColor}
        >
          {limitNumber(count)}
        </NotificationCounter>
      )}
    </div>
  );
};
IconButtonWithNotification.displayName = 'IconButtonWithNotification';

export default IconButtonWithNotification;
